<span class="bg-label mat-small {{color}}">{{ text }}</span>